import React, { Component } from 'react';
import styles from './index.css';
import fonts from '../../../iconfonts.css';
import {observer} from 'mobx-react'
import {time, score, offers} from '../../stores/index'
import {finance as resultsObject} from '../../stores/index';
import FontAwesome from "react-fontawesome";

@observer
export default class FooterMenu extends Component {

  cultures={
      "rape":"рапс",
      "wheat":"пшениця",
      "soy":"соя",
      "sunflower":"соняшник",
      "corn":"кукурудза"
  };

  render() {
      //побить на компоненты, ибо слишком много перерендерa
      return (
            <div className={styles.container}>
                <div className={styles.item + ' ' + styles.requests}>
                  <div className={styles.footerMenuHeading}>ВХІДНІ ЗАПИТИ</div>
                  <div className={styles.scrollableRequests}>
                      {offers.offers.map((item,i)=>(
                              item.status === 'new' ?
                                  <div className={styles.requestBar + ' ' + styles[item.culture]} key={i}>
                                      <span className={styles.requestItemDateTime}>{item.date.toLocaleDateString('ru',{ year: 'numeric', month: 'numeric', day: 'numeric' })}</span>&nbsp;&nbsp;&nbsp;
                                      <span className={styles.requestItemType}>Відгрузка</span>&nbsp;
                                      <span className={styles.requestItemCulture}>{this.cultures[item.culture]}</span>&nbsp;&nbsp;&nbsp;
                                      <span className={styles.requestItemWeight}>{item.amount} т.</span>
                                      <div className={styles.requestBarRefuse}
                                        onClick={()=>offers.offers[i].setStatus('failed')}
                                      > <FontAwesome name="times-circle"/></div>
                                  </div>
                                  : null
                          )
                      )}
                  </div>
                </div>
                <Stats />
                <Timer />
            </div>
        );
    }
}


@observer
class Stats extends Component{

    cashTotal(data={}){
        let result = 0;
        let expensesType = ['cashYield', 'directExpends', 'indirectExpends'];
        expensesType.forEach((item,i)=>{
            let sum = Object.keys(data).reduce((previousValue, currentValue) => {
                if(currentValue === 'elem' || currentValue === 'total') return previousValue;
                return previousValue + data[currentValue][item];
            },0);
            if(!i){result+=sum}else{result-=sum}
        });
        return (result /score.total*100);
    }

  render(){
      const input = this.cashTotal(resultsObject['input']);
      const drying = this.cashTotal(resultsObject['drying']);
      const cleaning = this.cashTotal(resultsObject['cleaning']);
      const storage = this.cashTotal(resultsObject['storage']);
      const output = this.cashTotal(resultsObject['output']);
      const transhipment = this.cashTotal(resultsObject['transhipment']);
      const total = input + drying + cleaning + storage + output + transhipment;
    return (
        <div className={styles.item + ' ' + styles.finResults}>
          <div className={styles.footerMenuHeading}>ФІНАНСОВІ ПОКАЗНИКИ</div>
          <div className={styles.footerResultsContainer}>
            <div className={styles.footerResultsItems}>
              <div>Приймання</div>
              <div className={styles.footerResultsIcon}><i className={fonts.iconInput}/></div>
              <div className={styles.footerResultsPercent}>{input.toFixed(2)}%</div>
            </div>
            <div className={styles.footerResultsItems}>
              <div>Сушка</div>
              <div className={styles.footerResultsIcon}><i className={fonts.iconDrying}/></div>
              <div className={styles.footerResultsPercent}>{drying.toFixed(2)}%</div>
            </div>
            <div className={styles.footerResultsItems}>
              <div>Очищення</div>
              <div className={styles.footerResultsIcon}><i className={fonts.iconCleaning}/></div>
              <div className={styles.footerResultsPercent}>{cleaning.toFixed(2)}%</div>
            </div>
            <div className={styles.footerResultsItems}>
              <div>Зберігання</div>
              <div className={styles.footerResultsIcon}><i className={fonts.iconStoring}/></div>
              <div className={styles.footerResultsPercent}>{storage.toFixed(2)}%</div>
            </div>
            <div className={styles.footerResultsItems}>
              <div>Вигрузка</div>
              <div className={styles.footerResultsIcon}><i className={fonts.iconOutput}/></div>
              <div className={styles.footerResultsPercent}>{output.toFixed(2)}%</div>
            </div>
            <div className={styles.footerResultsItems}>
              <div>Повернення капіталу</div>
              <div className={styles.footerResultsIcon}><i className={fonts.iconRoce}/></div>
              <div className={styles.footerResultsPercent}>{total.toFixed(2)}%</div>
            </div>
          </div>
        </div>
    )
  }
}

@observer
class Timer extends Component{

    static setSimulationSpeed(speed){
        if(speed !== time.timeSpeed) {
            time.breaker();
            time.setTimeSpeed(speed);
            time.startTime();
        }
    };

  render(){
    const timerAnimation = {strokeDashoffset: (245 - Math.floor( time.currentTime*time.tickCoef / 6.4))/16 + 'rem'};

    return (
        <div className={styles.item + ' ' + styles.gameControls}>
            <div className={styles.footerMenuHeading}>КЕРУВАННЯ МОДЕЛЮВАННЯМ</div>
            <div className={styles.footerTime}>{time.getTime}</div>
            <div className={styles.footerControlsContainer}>
                <div className={styles.footerControlsContainerItems} onClick={()=>{time.breaker();time.setTimeSpeed(0);}}>
                    <div className={styles.footerControls + (time.timeSpeed === 0 ? ' ' + styles.footerControlsActive : '')} >
                        <i className={fonts.iconPause}/>
                    </div>
                </div>
                <div className={styles.footerControlsContainerItems} onClick={()=> Timer.setSimulationSpeed(1)}>
                    <div className={styles.footerControls + ' ' + styles.playButton + (time.timeSpeed !== 0 ?  ' ' + styles.footerControlsActive : '')}>
                        <i className={fonts.iconPlay}/>
                    </div>
                </div>
                <div className={styles.footerControlsContainerItems} onClick={()=> Timer.setSimulationSpeed(2)}>
                    <div className={styles.footerControls +(time.timeSpeed >= 2 ? ' ' + styles.footerControlsActive : '')}>
                        <i className={fonts.iconPlay}/>
                        <i className={fonts.iconPlay}/>
                    </div>
                </div>
                <div className={styles.footerControlsContainerItems} onClick={()=> Timer.setSimulationSpeed(3)}>
                    <div className={styles.footerControls + (time.timeSpeed === 3 ? ' ' + styles.footerControlsActive : '')}>
                        <i className={fonts.iconPlay}/>
                        <i className={fonts.iconPlay}/>
                        <i className={fonts.iconPlay}/>
                    </div>
                </div>
                <div className={styles.footerControlsContainerItems}>
                    <div className={styles.footerControls + ' ' + styles.timerCircle}>
                        <span className={styles.footerControlsContainerTimer}>x{time.timeSpeed}</span>
                        <svg  className={styles.circle} xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <circle r="2.25rem" cy="2.5rem" cx="2.5rem" strokeWidth="2%" stroke="#e6e6e6" fill="none"/>
                                <circle style={timerAnimation} className={styles.timerAnimation} r="2.25rem" cy="2.5rem" cx="2.5rem" strokeWidth="2%" stroke="#0071e5" fill="none" id='timerAnimation' />
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
            <div className={styles.footerTimerDefinition}>Швидкість моделювання</div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/FooterMenu/index.js